import _ from 'underscore';
import { isMSStoreAdsCampaign } from '@bingads-webui-campaign-react/ms-store-ads-common';
import { defaultMSStoreMinSuggestionBid } from '@bingads-webui-campaign-legacy/budget/shared/defaultBid';
import inlineEditTemplate from '../../template/product-groups-inline-edit-bid.pug';
import { ProductGroupsEditBidBaseView } from './product-groups-edit-bid-base';

export class ProductGroupsEditBidsView extends ProductGroupsEditBidBaseView {
  initialize({
    view,
    deps,
    BidAmount,
    IsExcluded = false,
    selectedItems = [],
    IsAutoBidding,
    campaign,
  } = {}) {
    this.deps = deps;
    this.selectedItems = selectedItems;
    this.isAutoBidding = IsAutoBidding;
    this.defaultMSStoreMinSuggestionBid = defaultMSStoreMinSuggestionBid();
    this.IsMSStoreAds = !_.isEmpty(campaign) ? isMSStoreAdsCampaign(campaign) : false;
    const IsBidLessThan5CentsInShoppingCampaignEnabled = _.result(this.deps.config.get('Permissions'), 'IsBidLessThan5CentsInShoppingCampaignEnabled');
    let bidRangeKey = 'ProductGroupBidRange';
    if (this.IsMSStoreAds) {
      bidRangeKey = 'WindowsStoreAdsBidRange';
    }
    const originBidRange = this.deps.config.get(bidRangeKey);
    const accountCurrencyCode = this.deps.config.get('AccountCurrencyCode');
    const MinimumBid = _.result(this.deps.config.get('KeywordBidRange'), 'FloorValue');
    const fallbackMinBid = this.IsMSStoreAds ? 1 : 0.01;
    const range = {
      min: IsBidLessThan5CentsInShoppingCampaignEnabled ? _.result(originBidRange, 'FloorValue', fallbackMinBid) : MinimumBid,
      max: _.result(originBidRange, 'CeilingValue', 1000),
    };
    const defaultBidValue = accountCurrencyCode === 'USD' ? 1 : _.result(range, 'min');
    this.defaultBid = defaultBidValue;
    const bidRange = _.mapObject(range, val => this.deps.decimal.fromFloatToString(val, 2));
    const template = inlineEditTemplate;

    super.initialize({
      view,
      deps,
      model: {
        Amount: this.getBidAmount(BidAmount),
        IsExcluded,
      },
      bidProperty: 'Amount',
      validators: {
        Amount: [_.defaults({
          type: 'range',
          message: this.deps.i18n.getString('ProductGroupsGrid_BidRange_Validation', bidRange),
        }, range), {
          type: 'type',
          message: this.deps.i18n.getString('ProductGroupsGrid_BidFormat_Validation'),
        }],
      },
      selectedItems,
      template: values => template(_.defaults(values, {
        isBidBoost: false,
        bulkEditHeaderText: this.deps.i18n.getString('ProductGroupsGrid_BulkEdit_HeaderText'),
        bulkEditLabel: this.deps.i18n.getString('ProductGroupsGrid_BulkEdit_DescriptionText'),
        isAutoBidding: this.isAutoBidding,
      })),
      IsAutoBidding,
      defaultMSStoreMinSuggestionBid: this.defaultMSStoreMinSuggestionBid,
      validateMinSuggestionBid: this.validateMinSuggestionBid,
    });
  }

  bidInput() {
    this.validateMinSuggestionBid();
  }

  validateMinSuggestionBid() {
    const bidValue = this.viewModel.Amount();
    if (this.IsMSStoreAds && !this.viewModel.IsExcluded()) {
      this.viewModel.showLowerThanMinSuggestionBidWarning(bidValue < this.defaultMSStoreMinSuggestionBid);
    }
  }

  getBidAmount(BidAmount) {
    const bidAmount = _.isUndefined(BidAmount) || _.isNull(BidAmount) ?
      { Bid: { Amount: this.defaultBid } } : BidAmount;
    const bidValue = bidAmount.Bid.Amount;
    return bidValue == null ? this.defaultBid : bidValue;
  }

  getUpdated() {
    let updated;
    if (this.viewModel.IsExcluded()) {
      updated = { ..._.pick(this.selectedItems[0], 'Id', 'CampaignId', 'AdGroupId'), IsExcluded: true };
    } else {
      updated = {
        ..._.pick(this.selectedItems[0], 'Id', 'CampaignId', 'AdGroupId', this.getFieldName()),
        BidAmount: {
          Bid: {
            Amount: this.getValue().bidValue,
          },
        },
      };
    }
    if (!this.viewModel.IsExcluded() && this.selectedItems[0].IsExcluded) {
      updated.IsExcluded = false;
    }
    return updated;
  }

  genEditSchema() {
    const bidEditSchema =
      this.deps.s$ProductGroup.properties.BidAmount.schema.properties.Bid.schema;
    bidEditSchema.properties.IsExcluded = this.deps.s$ProductGroup.properties.IsExcluded;
    return bidEditSchema;
  }

  getFieldName() {
    return ['BidAmount', 'IsExcluded'];
  }

  getValue() {
    const bidValue = this.isAutoBidding ? this.defaultBid : this.viewModel.Amount().toString();
    return {
      bidValue: this.viewModel.IsExcluded() ? null : bidValue,
    };
  }
}
